import { render, staticRenderFns } from "./product-details-seo.vue?vue&type=template&id=033bb002&scoped=true&"
import script from "./product-details-seo.vue?vue&type=script&lang=js&"
export * from "./product-details-seo.vue?vue&type=script&lang=js&"
import style0 from "./product-details-seo.vue?vue&type=style&index=0&id=033bb002&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033bb002",
  null
  
)

export default component.exports